import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {ReactiveFormsModule, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {NgClass, NgForOf, NgIf} from "@angular/common";

export enum Tab {
  All = 'See All',
  LicenseType = 'License Type',
  Platform = 'Platform',
}

export enum LicenseTypeChoice {
  Student = 'Student',
  Employee = 'Employee',
  University = 'University',
}

export enum PlatformChoice {
  Windows = 'Windows',
  Mac = 'Mac',
  Linux = 'Linux',
  Other = 'Other',
}

interface FilterForm {
  tab: Tab;
  licenseTypeChoice: LicenseTypeChoice;
  platformChoice: PlatformChoice;
}

export interface FilterChoice {
  licenseTypeChoice?: LicenseTypeChoice;
  platformChoice?: PlatformChoice;
}

@Component({
  selector: 'app-product-filter-chooser',
  templateUrl: './product-filter-chooser.component.html',
  styleUrls: ['./product-filter-chooser.component.scss'],
  standalone: true,
  imports: [
    ReactiveFormsModule,
    NgForOf,
    NgClass,
    NgIf
  ]
})
export class ProductFilterChooserComponent implements OnInit {
  Tab = Tab;

  @Output() filterUpdate = new EventEmitter<FilterChoice>();

  filterTabs: Tab[] = [
    Tab.All,
    Tab.LicenseType,
    Tab.Platform,
  ];

  licenseTypes: LicenseTypeChoice[] = [
    LicenseTypeChoice.Student,
    LicenseTypeChoice.Employee,
    LicenseTypeChoice.University,
  ];

  platforms: PlatformChoice[] = [
    PlatformChoice.Windows,
    PlatformChoice.Mac,
    PlatformChoice.Linux,
    PlatformChoice.Other,
  ];

  filterSelection: UntypedFormGroup = this.formBuilder.group({
    tab: new UntypedFormControl(Tab.All),
    licenseTypeChoice: new UntypedFormControl(),
    platformChoice: new UntypedFormControl()
  });

  constructor(private readonly formBuilder: UntypedFormBuilder) {
  }

  ngOnInit(): void {
    this.filterSelection.valueChanges
      .pipe()
      .subscribe(this.filterChange.bind(this));

    this.filterSelection.updateValueAndValidity({onlySelf: false, emitEvent: true});
  }

  filterChange(form: FilterForm): void {
    this.filterUpdate.emit(
      {
        platformChoice: (form.tab === Tab.Platform && form.platformChoice) || undefined,
        licenseTypeChoice: (form.tab === Tab.LicenseType && form.licenseTypeChoice) || undefined,
      }
    );
  }
}
